import {
  CookieCategory,
  getBrowserCookie,
  setBrowserCookie,
  useOneTrustConsentCategory,
} from '@moonpig/web-core-browser-storage'
import { CustomerSegment } from '@moonpig/web-core-types-graphql'
import { useEffect } from 'react'

type CacheCustomerSegmentsProps = {
  segments: Array<CustomerSegment> | null
  isLoggedIn: boolean
}

type CacheCustomerSegments = (props: CacheCustomerSegmentsProps) => null

export const CacheCustomerSegments: CacheCustomerSegments = ({
  segments,
  isLoggedIn,
}) => {
  const userHasConsented = useOneTrustConsentCategory(CookieCategory.FUNCTIONAL)

  useEffect(() => {
    if (userHasConsented && isLoggedIn) {
      const cachedSegments = getBrowserCookie('mnpg_customer_segments')

      if (!cachedSegments && segments) {
        setBrowserCookie(
          'mnpg_customer_segments',
          JSON.stringify(segments),
          { maxAge: 3600, path: '/' }, // 1 hour in seconds
          CookieCategory.FUNCTIONAL,
        )
      }
    }
  }, [isLoggedIn, segments, userHasConsented])

  return null
}
